import React from "react";

import "leaflet/dist/leaflet.css";

import Menu1 from "./components/Menu";

import withRouter from "./withRouter";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import config from "./config.js";

import { StoreContext } from "./store/RootStore";
import { observer } from "mobx-react";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import drive7Icon from '../src/assets/images/drive7.ico';
import awtlIcon from '../src/assets/images/awtl.ico';
import starlingIcon from '../src/assets/images/starling.ico';
import secureIcon from '../src/assets/images/secure.ico';
import technautoIcon from "../src/assets/images/technauto.ico";
import { decode as base64_decode, encode as base64_encode } from "base-64";


if (config.project === "securetrack") {
     import("./secureTrack.css");
}
if (config.project === "trackon") {
     import("./trackon.css");
}
console.log('project: -',config.project);
class App extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = { collapsed: false, marginLeft: 80, settingColor: "white" };
    // console.log(props);
    

    let isMarine = JSON.parse(base64_decode(Cookies.get("data"))).industry;
    
    
    if(isMarine=='Marine'){
        context.setLocale("marine")
    }else{
      let isArabic = Number(JSON.parse(JSON.stringify(Cookies.get())).isArabic);
    // console.log(isArabic);
      isArabic ? context.setLocale("arabic") : context.setLocale("english");
      
    }
    console.log(isMarine)
   
  }

  
  handlePopState = () => {
    // For example, navigate to the login page
    this.props.navigate("/login");
  };
  async componentDidMount() {
    //alert('alert');
    window.addEventListener("popstate", this.handlePopState);
  }

  updateTitle = () => {
    return config.tabTitle ? config.tabTitle : "Trackeazy" 
  }
  updateTitle2 = () => {
    if (config.project === "drive7") {
      return "Drive7";
    } else if (config.project === "awtltrack") {
      return "AWTL";
    } else if (config.project === "starlingeye") {
      return "Starlingeye";
    } else if (config.project === "trackeazy") {
      return "Trackeazy";
    } else if (config.project === "securetrack") {
      return "SecureTrack";
    } else if (config.project === "technauto") {
      return "FleetEdge";
    } else {
      return "Trackeazy";
    }
  };

    updateIcons = ()=>{
     return {
        favicon: `/logos/${config.project}-favicon.ico`,
        appleTouchIcon: drive7Icon,
      };
  }
  updateIcons2 = () => {
    if (config.project === "drive7") {
      return {
        favicon: drive7Icon,
        appleTouchIcon: drive7Icon,
      };
    } 
    else if (config.project === "awtltrack") {
      return {
        favicon: awtlIcon,
        appleTouchIcon: awtlIcon,
      };
    } else if (config.project === "starlingeye") {
      return {
        favicon: starlingIcon,
        appleTouchIcon: starlingIcon,
      };
    } else if (config.project === "trackeazy") {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    } else if (config.project === "securetrack") {
      return {
        favicon: secureIcon,
        appleTouchIcon: secureIcon,
      };
    }else if (config.project === "technauto") {
          return {
            favicon: technautoIcon,
            appleTouchIcon: technautoIcon,
          };
      }else {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    }
  };
  render() {
    const { favicon, appleTouchIcon } = this.updateIcons();
    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>
        <div className={config.project === "drive7" ? "drive7-wrapper" : ""}>
          <Menu1 />
        </div>
      </>
    );
  }
}

// export default withRouter(App);
App.contextType = StoreContext;
export default observer(withRouter(App));
